export default "__VITE_ASSET__BYz6bv78__"